import Vue from 'vue'
import OverproductionPlanning from '@js/forms/overproduction/OverproductionPlanning.vue'

if ($('#overproduction_planning').length) {
  new Vue({
    el: '#overproduction_planning',
    components: { OverproductionPlanning }
  })
}
